<div class="page-container page-containers content-w-98">
  <div class="page-head">
    <div class="page-title">
      <span class="headerName">{{ headerData!.name }}</span>
    </div>
  </div>
  <div>
    <div>
      <div class="row">
        <div
          class="col-md-12"
          *ngrxLet="{
            dataLoaded: (sharedFacade.isLoaded$ | async),
            isClearSearch: (sharedFacade.isClearSearch$ | async)
          } as sharedData"
        >
          <ng-container>
            <piqet-angular-portlet
              [columnDefs]="columnDefs"
              [frameworkComponents]="frameworkComponents"
              [headerBtn]="btnName"
              [gridData]="prodUseList"
              (openBtnModal)="openProdUseModal(0, 'Add product use')"
              [createAccess]="showEdit"
              [class]="'fixedHeight'"
              [searchInputSize]="true"
              [isClearSearch]="sharedData.isClearSearch"
              [gridName]="'Product use grid'"
            ></piqet-angular-portlet>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer justify-content-start">
    <button type="button" class="btn back-btn modelBtn" (click)="backRoute()">
      <i class="bi bi-arrow-left checkboxLeft-div"></i> Back
    </button>
    <button type="button" class="btn next-btn modelBtn" (click)="nextRoute()">
      {{ backBtnLabel }} <i class="bi bi-arrow-right checkbox-div"></i>
    </button>
  </div>
</div>
